/**
 * Chatbot ilk temas tanıtımının kararı. Tamamen saf: depolamaya, DOM'a ve React'e dokunmaz —
 * bayrakları çağıran okur (bkz. introStorage.ts). Bu ayrım sayesinde karar test edilebilir kalır.
 */

/** Bu oturumda ne yapılacak. */
export type IntroPlan =
  /** Paneli kendiliğinden aç ve tanıtım kartını göster (ilk temas). */
  | 'auto-open'
  /** FAB yanında kısa hatırlatma balonu göster. */
  | 'nudge'
  /** Hiçbir şey yapma. */
  | 'none'

export interface IntroFlags {
  /** Bu hesap tam tanıtım kartını daha önce gördü (kalıcı). */
  introSeen: boolean
  /** Kullanıcı hatırlatma balonunu X'ledi → bir daha hiç gösterilmez (kalıcı). */
  nudgeDismissed: boolean
  /** Bu tarayıcı sekmesinde tanıtım ya da balon zaten bir kez tetiklendi. */
  shownThisSession: boolean
  /** Mobil genişlik. Panel orada tam ekran açılıp arka plan kaydırmasını kilitler. */
  isMobile: boolean
}

export function resolveIntroPlan(flags: IntroFlags): IntroPlan {
  // Kalıcı susturma ve oturum başına tek tetikleme her şeyin önünde gelir.
  if (flags.nudgeDismissed || flags.shownThisSession) return 'none'
  // Mobilde davetsiz tam ekran kaplama yapmayız; kart, balona dokunulunca gösterilir.
  if (!flags.introSeen && !flags.isMobile) return 'auto-open'
  return 'nudge'
}
